import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"fish"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M12.5 5.00018C10.9687 4.50018 7 5.00019 6 6.00019L8 9.00018C7 10.5002 6 12.0002 6 15.0002C6 15.0002 3.5 15.0002 2 16.0002L8 22.0002C9 20.5002 9 19.5002 9 18.0002C11 18.0002 14 17.5002 16 16.0002L16.9964 18.0019C19.1019 15.8964 19.5 13.0002 19.5 13.0002C21.9749 9.8182 21.3531 5.30094 21 4.00018C17.4994 3.34255 14.6213 3.58597 12.5 5.00018Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12.5 5.00018C10.9687 4.50018 7 5.00019 6 6.00019L8 9.00018C7 10.5002 6 12.0002 6 15.0002C6 15.0002 3.5 15.0002 2 16.0002L8 22.0002C9 20.5002 9 19.5002 9 18.0002C11 18.0002 14 17.5002 16 16.0002L16.9964 18.0019C19.1019 15.8964 19.5 13.0002 19.5 13.0002C21.9749 9.8182 21.3531 5.30094 21 4.00018C17.4994 3.34255 14.6213 3.58597 12.5 5.00018ZM12.5 5.00018C12.3333 6.33352 13.2999 9.30019 16.4999 10.5002","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M17.4998 6.99414L17.4971 6.9969L17.4998 6.99967L17.5026 6.9969L17.4998 6.99414Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Fish = Vue.extend<IconProps>({
  name: 'FishIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'fish',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Fish;
